import { Text } from '@latitude/text';

export default Text;
